/**
 * This script handles the logout process for vip customers, including clearing the cart before redirecting to the logout page.
**/

document.addEventListener('DOMContentLoaded', () => {
    const logoutBtn = document.querySelector('a[data-logout]');

    if(!logoutBtn) return;
    /**
     * Clears the cart and returns a promise.
    **/
    async function clearCart() {
        try {
            const response = await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                console.log('Cart cleared successfully');
                return true;
            } else {
                console.error('Failed to clear cart');
                return false;
            }
        } catch (error) {
            console.error('Error clearing cart:', error);
            return false;
        }
    }

    logoutBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const cartCleared = await clearCart();
        
        if (cartCleared) {
            window.location.reload();
            window.location.href = '/account/logout';
        } else {
            // If cart clearing fails, reload the page
            window.location.reload();
        }
    });
});